import React from 'react';
import { styled, Card, HtmlRenderer } from '@teko/ui';

const StyledCard = styled(Card)`
  .card-body {
    padding: 1rem;
  }
`;
const Article = React.forwardRef(({ content, title }, ref) => {
  return /* @__PURE__ */ React.createElement(StyledCard, {
    ref,
    header: title
  }, /* @__PURE__ */ React.createElement(HtmlRenderer, {
    content
  }));
});
Article.displayName = "Article";

export { Article };
